import { LemmonPOSAppType } from "@app/server/index";
import { hc } from "hono/client";
import { ref, Ref } from "vue";
import { createRoutingFetch, type RoutingConfig } from "./routing-fetch";
import { createServerRoutingController } from "./server-routing";

const isProduction = import.meta.env.VITE_ENV === "production";
const isLocal = !!import.meta.env.VITE_LOCALHOST;
const isPRPreview = window.location.host.endsWith("lemmonhq.workers.dev");

export const routingConfig: Ref<RoutingConfig> = ref({
  mode: "auto",
  order: ["primary", "secondary"],
  servers: {
    primary: {
      baseUrl: isProduction
        ? "https://pos-production.thelemmon.ch"
        : isLocal || isPRPreview
          ? "/"
          : "https://pos-staging.thelemmon.ch",
    },

    secondary: {
      baseUrl: isProduction
        ? "https://pos-production-2.hq.thelemmon.ch"
        : isLocal || isPRPreview
          ? "/"
          : "https://pos-staging-2.hq.thelemmon.ch",
    },
  },
});
console.debug("routingConfig", routingConfig);

export const serverRouting = createServerRoutingController(routingConfig);

const fetchViaRoute = createRoutingFetch(routingConfig);

// Waits for the first routing answer (at most a couple of seconds after boot)
// so startup requests don't go to the primary during a failover. The routing
// check itself uses plain fetch, so this cannot wait on itself.
export const routingFetch: typeof fetchViaRoute = async (input, init) => {
  await serverRouting.ready();
  return fetchViaRoute(input, init);
};

export const getAPIClient = () => {
  const client = hc<LemmonPOSAppType>("/", {
    // Custom fetch retries across configured servers when a request fails due
    // to server errors (5xx), preferring the primary route first.
    fetch: routingFetch,
  });
  return client;
};

export type APIClient = ReturnType<typeof getAPIClient>;
